import {createReducer, isAnyOf} from '@reduxjs/toolkit'
import {getEventId} from '@wix/wix-events-commons-statics'
import {EventsList, Tabs} from '../../../../commons/enums'
import {getEvents} from '../actions/events'
import {cancelRsvp, deleteRsvp} from '../actions/rsvp'
import {DetailedEvent, Events} from '../types/state'

const defaultState: Events = {
  upcoming: [],
  past: [],
  total: {
    past: 0,
    upcoming: 0,
  },
  error: false,
}

export const eventsReducer = createReducer(defaultState, builder => {
  builder
    .addCase(getEvents.fulfilled, (state, action) => {
      const {events, orders, rsvps} = action.payload
      const {tab} = action.meta.arg

      const key = tab === Tabs.PAST ? EventsList.PAST : EventsList.UPCOMING

      state[key] = [...state[key], ...detailedEvents(events, orders, rsvps)]
      state.total[key] = action.payload.total
      state.error = false
    })
    .addCase(getEvents.rejected, state => {
      state.error = true
    })
    .addMatcher(isAnyOf(cancelRsvp.fulfilled, deleteRsvp.fulfilled), (state, action) => {
      state.upcoming = state.upcoming.filter(event => getEventId(event.event) !== action.payload.eventId)
      state.total.upcoming = state.total.upcoming > 0 ? state.total.upcoming - 1 : state.total.upcoming
    })
})

export const detailedEvents = (
  events: wix.events.Event[],
  orders: wix.events.ticketing.Order[],
  rsvps: wix.events.rsvp.Rsvp[],
): DetailedEvent[] =>
  events.map(event => ({
    event,
    orders: orders ? orders.filter(order => order.eventId === getEventId(event)) : [],
    rsvp: rsvps ? rsvps.find(rsvp => rsvp.eventId === getEventId(event)) : null,
  }))
